import styled from "styled-components";

export const CardFormStepsContainer = styled.div`
  position: relative;
  padding: 32px 24px 8px;

  .processing-veil {
    position: absolute;
    inset: 0;
    background: rgba(255, 255, 255, 0.6);
    cursor: progress;
    z-index: 5;
  }

  .steps-container {
    align-self: center;
    width: 100%;
    padding: 0 6%;
    margin: 0 0 30px 0;
  }

  .title-container {
    display: flex;
    align-items: center;
    gap: 8px;
    margin: 0 -24px 24px;
    padding: 12px 24px;
    background: #fafafa;
    border-top: 1px solid rgba(0, 0, 0, 0.1);
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);

    img {
      width: 24px;
      height: 24px;
      object-fit: contain;
    }

    p {
      font-size: 17px;
      font-weight: 700;
      color: rgba(0, 0, 0, 0.88);
    }
  }

  @media (min-width: 768px) {
    padding: 32px 24px 8px;

    .steps-container {
      padding: 0 15%;
    }

    .title-container {
      margin: 0 -24px 24px;
      padding: 12px 24px;
    }
  }
`;
